import React, { useState, useEffect, useRef } from 'react';
// import { useHistory } from 'react-router-dom';
import { getpofinancetrackerbyidFromServer1, postapprovalPRFFromServer, getoverallFromServer } from '../../services/pofinancetracker';
// import { HttpClient } from '../common/httpClient';
import './overallprf.css';
import $ from 'jquery';
import axios from 'axios';
import { getUploadedFileNativePath } from '../../services/common/credentials';
import { AgGridReact } from 'ag-grid-react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

const OverallprfComponent = () => {
  // const history = useHistory();
  const [userdtl, setUserdtl] = useState();
  const [user, setUser] = useState();
  const [cardTitle, setCardTitle] = useState("Overall PRF");
  const [objporeq, setObjporeq] = useState();
  const [boolPoreqList, setBoolPoreqList] = useState(false);
  const [porequirementlist, setPorequirementlist] = useState();
  const [porequirementdetail, setPorequirementdetail] = useState();
  const [porequirmentDetails, setPorequirmentDetails] = useState();
  const [editporequirement, setEditporequirement] = useState();
  const [editporeq, setEditporeq] = useState();
  const [show, setshow] = useState(false);
  const [show1, setshow1] = useState(true);
  const [porequirmenttab, setPorequirmenttab] = useState();
  const [comment, setComment] = useState();
  const [poquotation, setpoquotation] = useState();
  const [fileupload, setFileUpload] = useState();
  const [financeresponse, setFinanceresponse] = useState();
  const [Tabval, setTabval] = useState();
  const [rowData, setrowData] = useState(null);

  const fileInput = useRef(null);

  const handleClose = () => {
    setshow(false);
  }

  const handleSubmit = () => {
    setshow(false);
  }

  const displayTable = () =>{
    setshow1(false);
  }
  const displayModel = () => {
    setshow(true);
    setBoolPoreqList(true);
  }

  useEffect(() => {
    setUserdtl(JSON.parse(localStorage.getItem('useracess')));
    setUser(JSON.parse(localStorage.getItem('Userdtl')));
    setComment("");
    getporequirementlist();
  }, []);



  const approveorder = (i) => {
    const Indata = {
      tenant_id: userdtl.tenant_id,
      entity_id: userdtl.entity_id,
      group_id: userdtl.group_id,
      module_id: userdtl.module_id,
      user_id: user.user_id,
      requirement_id: objporeq.requirement_id,
      is_finance_approved: i,
      remarks: comment
    };

    var getFileUploadsList = postapprovalPRFFromServer();

    axios.get(getFileUploadsList[1], { params: Indata }, getFileUploadsList[0])
      .then((recieveddata) => {
        const tempresponsedata = recieveddata;
        console.log("porequirementlist---", tempresponsedata);
        setFinanceresponse(tempresponsedata);
      });

    if (financeresponse.Status === "Success") {
      if (i === 1) {
        alert("PRF no:" + objporeq.prf_number + "Approved Sucessfully");
        list();
      } else if (i === 2) {
        alert("PRF no:" + objporeq.prf_number + "Holded Sucessfully");
        list();
      } else if (i === 3) {
        alert("PRF no:" + objporeq.prf_number + "Rejected Sucessfully");
        list();
      }
    }
    setComment("");
    $("#modal_approval").modal("hide");
  };

  const closemodel = () => {
    $("#modal_approval").modal("hide");
  };

  const list = () => {
    setBoolPoreqList(false);
    getporequirementlist();
  };

  const getporequirementlist = () => {
    const Indata = {
      tenant_id: 1,
      entity_id: 1,
      group_id: 1,
      module_id: 1,
      user_id: 24,
    };
    console.log("inputporequirementlist", Indata);
    var getFileUploadsList = getoverallFromServer();

    axios.post(getFileUploadsList[1], Indata, getFileUploadsList[0])
      .then((recieveddata) => {
        const tempresponsedata = recieveddata;
        let data = tempresponsedata?.data;
        console.log("porequirementlist---", tempresponsedata);
        setPorequirementlist(tempresponsedata);
        setPorequirementdetail(tempresponsedata.data);
        setrowData(data?.data);

      });
  };



  const ShowPorequirementdetail = (data) => {
    console.log('dataaaa', data.data);
    let data1 = data.data;
    const objporeq = {
      requirement_id: data1.requirement_id,
      tenant_id: 1,
      entity_id: 1,
      group_id: 1,
      module_id: 1,
      user_id: 24
    };
    console.log("EDITinputporequirement", objporeq);
    var getFileUploadsList = getpofinancetrackerbyidFromServer1();

    axios.post(getFileUploadsList[1], objporeq, getFileUploadsList[0])
      .then((recieveddata) => {
        const tempresponsedata = recieveddata.data;
        const finaldata = tempresponsedata.po_requirement;
        console.log("prfeditresponse---", tempresponsedata);
        setEditporequirement(tempresponsedata);
        setEditporeq(tempresponsedata.po_requirement);
        console.log('finaldata', finaldata);
        const poreq = finaldata?.prf_list;
        const porequirmentDetails = finaldata?.requirement_info;
        const porequirmenttab = finaldata?.poquotation;

        setPorequirmentDetails(porequirmentDetails);
        setPorequirmenttab(porequirmenttab);

        console.log("prfreqinfo---", porequirmentDetails);
        console.log("poquotation---", porequirmenttab);
        console.log("poreq---", poreq);

        setObjporeq({

          requirement_id: poreq[0].requirement_id,
          requirement_date: poreq[0].requirement_date,
          reporting_manager: poreq[0].reporting_manager,
          purpose: poreq[0].purpose,
          purchase_type: poreq[0].purchase_type,
          purchase_catagory: poreq[0].purchase_catagory,
          prf_number: poreq[0].prf_number,
          perceived_benefits: poreq[0].perceived_benefits,
          location: poreq[0].location,
          is_budgeted: poreq[0].is_budgeted,
          finalized_vendor: poreq[0].finalized_vendor,
          department: poreq[0].department,
          date_of_delivery_expected: poreq[0].date_of_delivery_expected,
          budget_allocated: poreq[0].budget_allocated,
          delivery_address: poreq[0].delivery_address,
          payment_term: poreq[0].payment_term,
          total_line_value: poreq[0].total_line_value,
          vendor_selection_reason: poreq[0].vendor_selection_reason,
          approver_mailid: poreq[0].approver_mailid,
          approver_name: poreq[0].approver_name,
          approver_department: poreq[0].approver_department,
          VendorFile_name: poreq[0].VendorFile_name,
          is_processed: poreq[0].is_processed,
          po_file_name: poreq[0].po_file_name,
          SupportFile_name: poreq[0].SupportFile_name
        });

        setpoquotation({
          vendor_type: porequirmenttab[0].vendor_type,
          vendor_name: porequirmenttab[0].vendor_name,
          vendor_code: porequirmenttab[0].vendor_code,
          vendor_location: porequirmenttab[0].vendor_location,
          vendor_address: porequirmenttab[0].vendor_address,
          gst_number: porequirmenttab[0].gst_number,
          vendor_emailid: porequirmenttab[0].vendor_emailid,
          quotationfile_name: porequirmenttab[0].quotationfile_name,
        }
        );

        setBoolPoreqList(true);
      });
  };

  // const tabclick = (param) => {
  //   setTabval("");
  //   setTabval(param);
  //   console.log(Tabval);
  // };

  // const openComparisonModal = () => {
  //   $("#quotation_Modal").modal("show");
  // };

  // const closemodal = () => {
  //   $("#quotation_Modal").modal("hide");
  // };

  // const HandleErrorResponse = (err) => {
  //   console.log("Error", err);
  // };

  var gridColumns = [

    { field: 'prf_number', headerName: 'PRF Number', sortable: true, filter: true, resizable: true },
    { field: 'requirement_date', headerName: 'Requirement Date', sortable: true, filter: true, resizable: true },
    { field: 'department', headerName: 'Department', sortable: true, filter: true, resizable: true },
    { field: 'purpose', headerName: 'Purpose', sortable: true, filter: true, resizable: true },
    { field: 'purchase_catagory', headerName: 'PurchaseCategory', sortable: true, filter: true, resizable: true },
    { field: 'po_status', headerName: 'Status', sortable: true, filter: true, resizable: true },
    { field: 'Comments', headerName: 'Comments', sortable: true, filter: true, resizable: true },
    {
      headerName: 'Edit',
      cellRendererFramework: (params) => (
        <button
          onClick={() => ShowPorequirementdetail(params)}
          className="delete-button"
        >
          <i className="fa fa-edit" aria-hidden="true"></i>
        </button>
      ),
      width: 80,
    },

  ]
  // Rest of the code...

  return (
    <>
    <div className="content-wrapper">
      <section className="content">
        <div className="container-fluid">
          <div className="block-header">
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item bcrumb-1">
                    <a href="../../Dashboard">
                      <i className="fa fa-home"></i> Home
                    </a>
                  </li>
                  <li className="breadcrumb-item active">OverAll PRF</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="card1">
                <form>
                  <div>
                    <h4 className="header d-flex justify-content-between">
                      {cardTitle}
                      <div hidden={!boolPoreqList} onClick={list}>
                        Back <i className="fa fa-hand-o-right"></i>
                      </div>
                    </h4>



                    <div hidden={!boolPoreqList}>
                      <div className="row">

                        <div className="form-group col-md-4 mb-2">
                          <table>
                            <tr className="pad-14">
                              <th className="pad-14">
                                <label htmlFor="userinput2">PRF No</label>
                              </th>
                              <th>{objporeq?.prf_number}</th>
                            </tr>
                            <tr>
                              <th className="pad-14">
                                <label htmlFor="userinput2">Requirement Date</label>
                              </th>
                              <th> {objporeq?.requirement_date}</th>
                            </tr>
                            <tr>
                              <th className="pad-14">
                                <label htmlFor="userinput2">Department</label>
                              </th>
                              <th> {objporeq?.department}</th>
                            </tr>
                          </table>
                        </div>
                        <div className="form-group col-md-4 mb-2">
                          <table>
                            <tr className="pad-14">
                              <th className="pad-14">
                                <label htmlFor="userinput2">Reporting Manager</label>
                              </th>
                              <th> {objporeq?.reporting_manager}</th>
                            </tr>
                            <tr>
                              <th className="pad-14">
                                <label htmlFor="userinput2">Purpose</label>
                              </th>
                              <th> {objporeq?.purpose}</th>
                            </tr>
                            <tr>
                              <th className="pad-14">
                                <label htmlFor="userinput2">Purchase Category</label>
                              </th>
                              <th> {objporeq?.purchase_catagory}</th>
                            </tr>
                          </table>
                        </div>
                        <div className="form-group col-md-4 mb-2">
                          <table>
                            <tr className="pad-14">
                              <th className="pad-14">
                                <label htmlFor="userinput2">Type of Purchase</label>
                              </th>
                              <th> {objporeq?.purchase_catagory}</th>
                            </tr>
                            <tr>
                              <th className="pad-14">
                                <label htmlFor="userinput2">Location</label>
                              </th>
                              <th> {objporeq?.location}</th>
                            </tr>
                            <tr>
                              <th className="pad-14">
                                <label htmlFor="userinput2">Budgeted</label>
                              </th>
                              <th> {objporeq?.is_budgeted}</th>
                            </tr>
                          </table>
                        </div>
                        <div className="form-group col-md-4 mb-2">
                          <table>
                            <tr className="pad-14">
                              <th className="pad-14">
                                <label htmlFor="userinput2">Date of Delivery Expected</label>
                              </th>
                              <th> {objporeq?.date_of_delivery_expected}</th>
                            </tr>
                            <tr>
                              <th className="pad-14">
                                <label htmlFor="userinput2">Delivery Address</label>
                              </th>
                              <th> {objporeq?.delivery_address}</th>
                            </tr>
                            <tr>
                              <th className="pad-14">
                                <label htmlFor="userinput2">Requirement Total</label>
                              </th>
                              <th> {objporeq?.budget_allocated}</th>
                            </tr>
                          </table>
                        </div>
                        <div className="form-group col-md-4 mb-2">
                          <table>
                            <tr className="pad-14">
                              <th className="pad-14">
                                <label htmlFor="userinput2">PaymentTerm</label>
                              </th>
                              <th>{objporeq?.payment_term} </th>
                            </tr>
                            <tr className="pad-14">
                              <th className="pad-14">
                                <label htmlFor="userinput2">perceived Benefits</label>
                              </th>
                              <th>{objporeq?.perceived_benefits} </th>
                            </tr>
                            <tr>
                              <th className="pad-14">
                                
                                  <a onClick={displayModel}><i className="fa fa-check-square-o"></i> Quotations</a>
                                
                              </th>
                            </tr>
                          </table>
                        </div>
                        <div className="form-group col-md-4 mb-2">
                          <table>
                            <tr>
                              <th className="pad-14">
                                <label htmlFor="userinput2">Approver Email ID</label>
                              </th>
                              <th> {objporeq?.approver_mailid}</th>
                            </tr>

                            <tr>
                              <th className="pad-14">
                                <label htmlFor="userinput2">Approver name</label>
                              </th>
                              <th> {objporeq?.approver_name}</th>
                            </tr>
                            <tr>
                              <th className="pad-14">
                                <label htmlFor="userinput2">Approver Department</label>
                              </th>
                              <th> {objporeq?.approver_department}</th>
                            </tr>
                          </table>
                        </div>
                        <div className="form-group col-md-4 mb-2">
                          <table>
                            <tr>
                              <th className="pad-14">
                                <label htmlFor="userinput2">PO Doc</label>
                              </th>
                              <th>
                                <a className="text-primary cursor-pointer" target="_blank" href="http://65.1.209.204:10002/static/PO07688_Team_Computers_Pvt_Ltd__Delhi_2021_07_13_14_46_41_447511.pdf">
                                  {objporeq?.po_file_name}
                                </a>
                              </th>
                            </tr>

                            <tr>
                              <th className="pad-14">
                                <label htmlFor="userinput2">Supporting Doc</label>
                              </th>
                              <th>
                                <a className="text-primary cursor-pointer" target="_blank" href="http://65.1.209.204:10002/static/">
                                  {objporeq?.SupportFile_name}
                                </a>
                              </th>
                            </tr>
                            <tr>
                              <th className="pad-14">
                                <label htmlFor="userinput2">Vendor Doc</label>
                              </th>
                              <th>
                                <a className="text-primary cursor-pointer" target="_blank" href="http://65.1.209.204:10002/static/">
                                  {objporeq?.VendorFile_name}
                                </a>
                              </th>
                            </tr>
                          </table>
                        </div>


                        {/* {porequirmenttab?.map((poqutation, i) => (
                          <div key={i} className="form-group col-md-4 mb-2">
                            <table>
                              <tr className="pad-14">
                                <th className="pad-14">
                                  <label htmlFor="userinput2">Vendor Type</label>
                                </th>
                                <th className="pad-14">
                                  {poqutation.vendor_type}
                                </th>
                              </tr>
                              <tr>
                                <th className="pad-14">
                                  <label htmlFor="userinput2">Vendor Name</label>
                                </th>
                                <th className="pad-14">
                                  {poqutation.vendor_name}
                                </th>
                              </tr>
                              <tr>
                                <th className="pad-14">
                                  <label htmlFor="userinput2">Vendor Code</label>
                                </th>
                                <th className="pad-14">
                                  {poqutation.vendor_code}
                                </th>
                              </tr>
                            </table>
                          </div>
                        ))}
                        {porequirmenttab?.map((poqutation, i) => (
                          <div key={i} className="form-group col-md-4 mb-2">
                            <table>
                              <tr className="pad-14">
                                <th className="pad-14">
                                  <label htmlFor="userinput2">Vendor Location</label>
                                </th>
                                <th className="pad-14">
                                  {poqutation.vendor_location}
                                </th>
                              </tr>
                              <tr>
                                <th className="pad-14">
                                  <label htmlFor="userinput2">Vendor Address</label>
                                </th>
                                <th className="pad-14">
                                  {poqutation.vendor_address}
                                </th>
                              </tr>
                              <tr>
                                <th className="pad-14">
                                  <label htmlFor="userinput2">Vendor GST Number</label>
                                </th>
                                <th className="pad-14">
                                  {poqutation.gst_number}
                                </th>
                              </tr>
                            </table>
                          </div>
                        ))}
                        {porequirmenttab?.map((poqutation, i) => (
                          <div key={i} className="form-group col-md-4 mb-2">
                            <table>
                              <tr>
                                <th className="pad-14">
                                  <label htmlFor="userinput2">Vendor Email ID</label>
                                </th>
                                <th className="pad-14">
                                  {poqutation.vendor_emailid}
                                </th>
                              </tr>
                              <tr>
                                <th className="pad-14">
                                  <label htmlFor="userinput2">Quotation Doc</label>
                                </th>
                                <th className="pad-14">
                                  <a
                                    className="text-primary cursor-pointer"
                                    href={getUploadedFileNativePath + poqutation.quotationfile_name}
                                    target="_blank"
                                  >
                                    {poqutation.quotationfile_name}
                                  </a>
                                </th>
                              </tr>
                            </table>
                          </div>
                        ))} */}
                      </div>

                      <div className="row pad-14">

                        {porequirmenttab?.map((poqutation) => (
                          <table className="table table-striped table-bordered" key={poqutation.pobudget_id}>
                            <thead>
                              <tr className="bg-light-gray2">
                                <th className="th-sm"> Material/Service Name </th>
                                <th className="th-sm"> Description </th>
                                <th className="th-sm"> Budget Category </th>
                                <th className="th-sm"> Quantity </th>
                                <th className="th-sm"> Approx Unit Value </th>
                                <th className="th-sm"> Approx Total Value </th>
                              </tr>
                            </thead>
                            <tbody>
                              {poqutation.quotation.map((quotationItem) => (
                                <tr key={quotationItem.pobudgetinfo_id}>
                                  <td>{quotationItem.vendor_material_name}</td>
                                  <td>{quotationItem.vendor_line_description}</td>
                                  <td>{quotationItem.budget_category}</td>
                                  <td>{quotationItem.vendor_quantity}</td>
                                  <td>{quotationItem.vendor_unit_value}</td>
                                  <td>{quotationItem.vendor_total_value}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        ))}


                        {/* {porequirmenttab?.map((poqutation, i) => (
                          <table className="table table-striped table-bordered" key={i}>
                            <thead>
                              <tr className="bg-light-gray2">
                                <th className="th-sm">Material/Service Name</th>
                                <th className="th-sm">Description</th>
                                <th className="th-sm">Quantity</th>
                                <th className="th-sm">Approx Unit Value</th>
                                <th className="th-sm">Approx Total Value</th>
                              </tr>
                            </thead>
                            <tbody>
                              {poqutation.quotation.map((cost, i) => (
                                <tr key={i}>
                                  <td>{cost.vendor_material_name}</td>
                                  <td>{cost.vendor_line_description}</td>
                                  <td>{cost.vendor_quantity}</td>
                                  <td>{cost.vendor_unit_value}</td>
                                  <td>{cost.vendor_total_value}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        ))} */}
                      </div>

                      <div className="row">
                        
                            <a onClick={displayTable}>
                              Quotation1
                            </a>
                        
                        <div className="tab-content" hidden={show1}>
                          <div className="tab-pane active show" id="poqutation_0">
                            <div className="row">

                              <div className="form-group col-md-4 mb-2">

                                <table>
                                  <tr className="pad-14">
                                    <th className="pad-14">
                                      <label htmlFor="userinput2">Vendor Type</label>
                                    </th>
                                    <th className="pad-14"> {poquotation?.vendor_type}</th>
                                  </tr>
                                  <tr className="pad-14">
                                    <th className="pad-14">
                                      <label htmlFor="userinput2">Vendor Name</label>
                                    </th>
                                    <th className="pad-14"> {poquotation?.vendor_name} </th>
                                  </tr>
                                  <tr className="pad-14">
                                    <th className="pad-14">
                                      <label htmlFor="userinput2">Vendor Code</label>
                                    </th>
                                    <th className="pad-14"> {poquotation?.vendor_code}</th>
                                  </tr>
                                </table>

                              </div>
                              <div className="form-group col-md-4 mb-2">
                                <table>
                                  <tr className="pad-14">
                                    <th className="pad-14">
                                      <label htmlFor="userinput2">Vendor Location</label>
                                    </th>
                                    <th className="pad-14">{poquotation?.vendor_location} </th>
                                  </tr>
                                  <tr className="pad-14">
                                    <th className="pad-14">
                                      <label htmlFor="userinput2">Vendor Address</label>
                                    </th>
                                    <th className="pad-14"> {poquotation?.vendor_address} </th>
                                  </tr>
                                  <tr className="pad-14">
                                    <th className="pad-14">
                                      <label htmlFor="userinput2">Vendor GST Number</label>
                                    </th>
                                    <th className="pad-14"> {poquotation?.gst_number} </th>
                                  </tr>
                                </table>
                              </div>
                              <div className="form-group col-md-4 mb-2">
                                <table>
                                  <tr className="pad-14">
                                    <th className="pad-14">
                                      <label htmlFor="userinput2">Vendor Email ID</label>
                                    </th>
                                    <th className="pad-14"> {poquotation?.vendor_emailid}</th>
                                  </tr>
                                  <tr className="pad-14">
                                    <th className="pad-14">
                                      <label htmlFor="userinput2">Quotation Doc</label>
                                    </th>
                                    <th className="pad-14">
                                      <a className="text-primary cursor-pointer" target="_blank" href="http://65.1.209.204:10002/static/cfm1_2021_07_02_11_45_55_385223.pdf">
                                        {poquotation?.quotationfile_name}
                                      </a>
                                    </th>
                                  </tr>
                                </table>
                              </div>

                            </div>
                            <div className="row pad-14">
                              {porequirmenttab?.map((poqutation) => (
                                <table className="table table-striped table-bordered" key={poqutation.pobudget_id}>
                                  <thead>
                                    <tr className="bg-light-gray2">
                                      <th className="th-sm"> Material/Service Name </th>
                                      <th className="th-sm"> Description </th>
                                      <th className="th-sm"> Budget Category </th>
                                      <th className="th-sm"> Quantity </th>
                                      <th className="th-sm"> Approx Unit Value </th>
                                      <th className="th-sm"> Approx Total Value </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {poqutation.quotation.map((quotationItem) => (
                                      <tr key={quotationItem.pobudgetinfo_id}>
                                        <td>{quotationItem.vendor_material_name}</td>
                                        <td>{quotationItem.vendor_line_description}</td>
                                        <td>{quotationItem.budget_category}</td>
                                        <td>{quotationItem.vendor_quantity}</td>
                                        <td>{quotationItem.vendor_unit_value}</td>
                                        <td>{quotationItem.vendor_total_value}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <div className="modal fade show" id="quotation_Modal" role="dialog" style={{ padding: '0 17px' }}>
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="quotation_Modal">
                Quotation Comparison
              </h5>
              <button className="close" data-dismiss="modal" type="button">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="form-group col-md-4">
                  <h6 className="modal-title" id="quotation_Modal">
                    Quotation 1
                  </h6>
                  <div className="row quotation">
                    <div className="form-group col-md-4">
                      <table>
                        <tr>
                          <th className="pad-14">
                            <label htmlFor="userinput2">Vendor Name</label>
                          </th>
                          <th className="pad-14"> Team Computers Pvt. Ltd -Delhi </th>
                        </tr>
                      </table>
                    </div>
                    <div className="form-group col-md-4">
                      <table>
                        <tr>
                          <th className="pad-14">
                            <label htmlFor="userinput2">Quotation Doc</label>
                          </th>
                          <th className="pad-14">
                            <a className="text-primary cursor-pointer" target="_blank" href="http://65.1.209.204:10002/static/cfm1_2021_07_02_11_45_55_385223.pdf">
                              cfm1_2021_07_02_11_45_55_385223.pdf
                            </a>
                          </th>
                        </tr>
                      </table>
                    </div>
                    <div className="form-group col-md-12">
                      <table className="table table-striped table-bordered">
                        <thead>
                          <tr className="bg-light-gray2">
                            <th> Material/Service Name </th>
                            <th> Description </th>
                            <th> Quantity </th>
                            <th> Approx Unit Value </th>
                            <th> Approx Total Value </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              <label>License renewal</label>
                            </td>
                            <td>
                              <label>CFM devices</label>
                            </td>
                            <td>
                              <label>4.00</label>
                            </td>
                            <td>
                              <label>16840.00</label>
                            </td>
                            <td>
                              <label>67360.00</label>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer"></div>
          </div>
        </div>
      </div> */}

      

      {/* <div className="modal fade" id="quotation_Modal" role="dialog">
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="quotation_Modal">
                Quotation Comparison
              </h5>
              <button type="button" className="close" data-dismiss="modal" onClick={closemodal} aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                {porequirmenttab?.map((poqutation, i) => (
                  <div key={i} className="form-group col-md-4">
                    <h6 className="modal-title" id="quotation_Modal">
                      Quotation {i + 1}
                    </h6>
                    <div className="row quotation">
                      <div className="form-group col-md-4">
                        <table>
                          <tr>
                            <th className="pad-14">
                              <label htmlFor="userinput2">Vendor Name</label>
                            </th>
                            <th className="pad-14">{poqutation.vendor_name}</th>
                          </tr>
                        </table>
                      </div>
                      <div className="form-group col-md-4">
                        <table>
                          <tr>
                            <th className="pad-14">
                              <label htmlFor="userinput2">Quotation Doc</label>
                            </th>
                            <th className="pad-14">
                              <a
                                className="text-primary cursor-pointer"
                                href={getUploadedFileNativePath + poqutation.quotationfile_name}
                                target="_blank"
                              >
                                {poqutation.quotationfile_name}
                              </a>
                            </th>
                          </tr>
                        </table>
                      </div>
                      <div className="form-group col-md-12">
                        <table className="table table-striped table-bordered">
                          <thead>
                            <tr className="bg-light-gray2">
                              <th>Material/Service Name</th>
                              <th>Description</th>
                              <th>Quantity</th>
                              <th>Approx Unit Value</th>
                              <th>Approx Total Value</th>
                            </tr>
                          </thead>
                          <tbody>
                            {poqutation?.quotation?.map((cost, i) => (
                              <tr key={i}>
                                <td>
                                  <label>{cost.vendor_material_name}</label>
                                </td>
                                <td>
                                  <label>{cost.vendor_line_description}</label>
                                </td>
                                <td>
                                  <label>{cost.vendor_quantity}</label>
                                </td>
                                <td>
                                  <label>{cost.vendor_unit_value}</label>
                                </td>
                                <td>
                                  <label>{cost.vendor_total_value}</label>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="modal-footer"></div>
          </div>
        </div>
      </div> */}



      <div className="report" hidden={boolPoreqList}>

        <div className="ag-theme-balham report-layer" style={{ width: '100%', heidght: '100%' }}>
          <AgGridReact
            columnDefs={gridColumns}
            rowData={rowData}
            paginationPageSize={20}
            pagination={true}
            animateRows={true}
            rowSelection={'multiple'}
            groupSelectsChildren={true}

            suppressAggAtRootLevel={true}
            suppressRowClickSelection={true}

          >
          </AgGridReact>
        </div>
      </div>
      
      <Modal
        show={show}
        size="lg"
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Quotation Comparison</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group col-md-12">
            <table>
              <tr>
                <th className="pad-14">
                  <label htmlFor="userinput2">Vendor Name</label>
                </th>
                <th className="pad-14"> {poquotation?.vendor_name} </th>
              </tr>
            </table>
          </div>
          <div className="form-group col-md-12">
            <table>
              <tr>
                <th className="pad-14">
                  <label htmlFor="userinput2">Quotation Doc</label>
                </th>
                <th className="pad-14">
                  <a className="text-primary cursor-pointer" target="_blank" href="http://65.1.209.204:10002/static/cfm1_2021_07_02_11_45_55_385223.pdf">
                    {poquotation?.quotationfile_name}
                  </a>
                </th>
              </tr>
            </table>
          </div>

          <div className="row pad-14">
            {porequirmenttab?.map((poqutation) => (
              <table className="table table-striped table-bordered" key={poqutation.pobudget_id}>
                <thead>
                  <tr className="bg-light-gray2">
                    <th className="th-sm"> Material/Service Name </th>
                    <th className="th-sm"> Description </th>
                    <th className="th-sm"> Budget Category </th>
                    <th className="th-sm"> Quantity </th>
                    <th className="th-sm"> Approx Unit Value </th>
                    <th className="th-sm"> Approx Total Value </th>
                  </tr>
                </thead>
                <tbody>
                  {poqutation.quotation.map((quotationItem) => (
                    <tr key={quotationItem.pobudgetinfo_id}>
                      <td>{quotationItem.vendor_material_name}</td>
                      <td>{quotationItem.vendor_line_description}</td>
                      <td>{quotationItem.budget_category}</td>
                      <td>{quotationItem.vendor_quantity}</td>
                      <td>{quotationItem.vendor_unit_value}</td>
                      <td>{quotationItem.vendor_total_value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleClose}>
            Close
          </Button>
          
        </Modal.Footer>
      </Modal>
      
    </div>
    </>
  );

};

export default OverallprfComponent;